import { type ComponentProps, type ReactElement } from 'react'
import { cn } from '@/lib/utils'

function Card ({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return (
    <div
      className={cn(
        'rounded-[10px] border border-(--bp-border) bg-(--bp-surface) shadow-(--shadow-sm)',
        className
      )}
      {...props}
    />
  )
}

function CardHeader ({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return <div className={cn('flex items-start justify-between gap-2 p-4', className)} {...props} />
}

function CardTitle ({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return <div className={cn('text-sm font-semibold text-(--bp-ink)', className)} {...props} />
}

function CardContent ({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return <div className={cn('px-4 pb-4', className)} {...props} />
}

function CardFooter ({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return <div className={cn('flex items-center gap-2 px-4 pb-4', className)} {...props} />
}

export { Card, CardHeader, CardTitle, CardContent, CardFooter }
